import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./hooks/useTheme";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import AppRoutes from "./routes/App.routes";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PWAStatusIndicator from "./components/PWAStatusIndicator";
import "./services/errorLogService"; // Inicializar o serviço de logs de erro

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ThemeProvider>
          <Router>
          <div
            className="App"
            style={{
              minHeight: "100vh",
              backgroundColor: "var(--color-background)",
            }}
          >
            {/* PWA Status Indicator - sempre no topo */}
            <PWAStatusIndicator />

            <Header />
            <AppRoutes />

            {/* PWA Install Prompt - overlay global */}
            <PWAInstallPrompt />
          </div>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
